import {useApi} from "@/composables/useApi";
import type {FileData} from "@/types/io";
export const useFiles = () => {

    const getFile = async (id: number) => {
        const { data, fetch } = useApi<FileData>({
            url: `files/${id}`,
            method: 'GET',
        });
        await fetch();
        return data.value;
    }

    // const getSupplyRoute = (code: string) => {
    //     return supplyRoutes.value?.find(s => s.code === code);
    // }
    //
    // const getSupplyRouteName = (code: string) => {
    //     return supplyRoutes.value?.find(s => s.code === code)?.name;
    // }
    //
    // if(!supplyRoutes.value) {
    //     await fetchSupplyRoutes();
    // }

    return {
        getFile,
    }
}